
import Compressor from 'compressorjs';

import { inspectionStatusEnum, typeFileVehicleInvolvedEnum, typeFileEnum } from './MochaData'
import {
    Auto1,
    Auto2,
    Auto3,
    Auto4,
    Auto5,
    Auto6,
    Auto7,
    Auto8,
    Auto9,
    Auto10,
    Auto11,
    Auto12
} from '../img/templates';

const formatString = (value: string) => value === '' ? null : value;
const formatBool = (value: string) => {
    if (value === 'S')
        return true;
    else if (value === 'N')
        return false;
    else
        return null;
}
const formatNumber = (value: string) => value === '' ? null : parseInt(value);
const formatDate = (value: string | undefined) => (value === '' || value === undefined )? null : new Date(value).toDateString();
const formatBase64 = (value: string) => {
    const newValue = value.split(';base64,')
    return newValue[1];
}

const compressFiles = async (file: File, nameFile: string) => {

    let promiseCompress = new Promise((resolve) => {
        new Compressor(file, {
            quality: 0.6,
            success(result) {
                resolve(result);
            }
        });
    })

    let data: IImageInspectionDto = {} as IImageInspectionDto

    await promiseCompress.then(async (x: any) => {

        let promiseBase64 = new Promise((resolve, reject) => {

            let reader = new FileReader();
            reader.readAsDataURL(x);
            reader.onload = () => {
                resolve(reader.result);
            };
        })

        let extArray = file.name.split('.');
        let ext = extArray[extArray.length - 1];

        await promiseBase64.then((resultBase64) => {
            data = {
                Nombre: `${nameFile}.${ext}`,
                AdjuntoBase64: resultBase64,
                Peso: x.size,
                Tipo: file.type,
                UltimaModificacion: new Date(file.lastModified),
                Usuario: '',
                TipoDocumento: 0
            } as IImageInspectionDto
        }).catch(error => console.log(error));

    }).catch(error => console.log(error))

    return data;
}

const buildDataUpdate = (data: IReclamoInspeccionNI, index: number, estado: number) => {
    if (index === 0 && estado === inspectionStatusEnum.cancelled && !data.registration)
        estado = inspectionStatusEnum.cancelled;

    let dt: IReclamoInspeccionNIDTO = {
        IdReclamosInspeccion: data.id,
        Estado: estado,
        Paso: index + 1,
        HuboLevantamientoAccidente: formatBool(data.registration),
        MontivoNoLevantamiento: formatString(data.reasonNotRegistered),
        OtroMotivoNoLevantamiento: formatString(data.anotherReason),
        EsAseguradoCondutorVehiculo: formatBool(data.isInsuredDriver),
        AseguradoNombre: formatString(data.insuredName),
        AseguradoCelular: formatString(data.insuredCellPhone),
        AseguradoCorreo: formatString(data.insuredMail),
        AseguradoDireccion: formatString(data.insuredAddress),
        ConductorTipoIdentificacion: formatString(data.driverIdentificationType),
        ConductorIdentificacion: formatString(data.driverIdentification),
        ConductorNombre1: formatString(data.driverFirstName1),
        ConductorNombre2: formatString(data.driverFirstName2),
        ConductorApellido1: formatString(data.driverLastName1),
        ConductorApellido2: formatString(data.driverLastName2),
        ConductorCelular: formatString(data.driverCellPhone),
        ConductorCorreo: formatString(data.driverMail),
        ConductorAcompaniantes: formatString(data.driverCompanions),
        SiniestroFecha: formatDate(data.sinisterDate),
        SiniestroHora: data.sinisterHourFormat,
        SiniestroDireccion: formatString(data.sinisterAddress),
        SiniestroUbicacionGPS: formatString(data.sinisterGPS),
        SePresentoPolicia: formatBool(data.policeOfficerShowedUp),
        NumeroChipPolicia: formatString(data.policeChip),
        SiniestroDetalle: formatString(data.sinisterDetail),
        ObservacionInspeccion: formatString(data.inspectionObservations),
        HuboOtroVehiculoInvolucrado: formatBool(data.isVehiclesInvolved),
        HuboPropiedadTerceroDanada: formatBool(data.isDamagedThirdPartyProperty),
        DetalleDanosPropiedad: formatString(data.damageDetail),
        HubieronPersonasLesionadas: formatBool(data.isInjuredPeople),
        CantidadLesionados: formatNumber(data.numberInjured),
        UnidadSaludFueronTrasladados: formatString(data.healthUnitWereTransferred),
        Origen: 1,
        HuboPersonasFallecidas: formatBool(data.HuboPersonasFallecidas),
        CantidadPersonasFallecidas: formatNumber(data.CantidadPersonasFallecidas)
    } as IReclamoInspeccionNIDTO

    return dt;
}

const buildDataVehicleInvolved = async (model: Array<IVehiclesInvolved>) => {
    let data: Array<IInspectionVehicleInvolvedDTO> = [];

    for await (const vehiclesInvolved of model) {
        let vehiclesInvolvedDTO: IInspectionVehicleInvolvedDTO = {
            Placa: vehiclesInvolved.carPlate ?? "",
            TipoIdentificacion: vehiclesInvolved.identificationType,
            NumeroIdentificacion: vehiclesInvolved.identification,
            Nombre1: vehiclesInvolved.firstName1,
            Nombre2: vehiclesInvolved.firstName2,
            Apellido1: vehiclesInvolved.lastName1,
            Apellido2: vehiclesInvolved.lastName2,
            Celular: vehiclesInvolved.cellPhone,
            Correo: vehiclesInvolved.mail,
            Adjuntos: undefined
        } as IInspectionVehicleInvolvedDTO;

        let attach = (await buildDataVehicleInvolvedFile(vehiclesInvolved.frontVehicleImage, typeFileVehicleInvolvedEnum.frontVehicleImage))
            .concat(await buildDataVehicleInvolvedFile(vehiclesInvolved.backVehicleImage, typeFileVehicleInvolvedEnum.backVehicleImage))
            .concat(await buildDataVehicleInvolvedFile(vehiclesInvolved.rightVehicleImage, typeFileVehicleInvolvedEnum.rightVehicleImage))
            .concat(await buildDataVehicleInvolvedFile(vehiclesInvolved.leftVehicleImage, typeFileVehicleInvolvedEnum.leftVehicleImage))
            .concat(await buildDataVehicleInvolvedFile(vehiclesInvolved.damageVehicleImage, typeFileVehicleInvolvedEnum.damageVehicleImage))
            .concat(await buildDataVehicleInvolvedFile(vehiclesInvolved.identificationFrontImage, typeFileVehicleInvolvedEnum.identificationFrontImage))
            .concat(await buildDataVehicleInvolvedFile(vehiclesInvolved.identificationBackImage, typeFileVehicleInvolvedEnum.identificationBackImage))

        vehiclesInvolvedDTO.Adjuntos = attach;
        data.push(vehiclesInvolvedDTO);
    }
    return data;
}

const buildDataVehicleInvolvedFile = async (files: Array<File> | undefined, type: typeFileVehicleInvolvedEnum) => {
    let lst: Array<IImageInspectionWithTypeDocumentDto> = [];
    if (files !== undefined && files.length > 0) {
        for (const file of files) {
            let newFile: IImageInspectionWithTypeDocumentDto = await compressFiles(file,`${nameFileVehicleInvolved[type]}_${getNewGuid(1)}` )
            newFile.TipoDocumento = type;
            lst.push(newFile)
        }
    }
    return lst;
}

const getAutoValue = (value: string) => {
    switch (value) {
        case 'Auto1': return Auto1
        case 'Auto2': return Auto2
        case 'Auto3': return Auto3
        case 'Auto4': return Auto4
        case 'Auto5': return Auto5
        case 'Auto6': return Auto6
        case 'Auto7': return Auto7
        case 'Auto8': return Auto8
        case 'Auto9': return Auto9
        case 'Auto10': return Auto10
        case 'Auto11': return Auto11
        case 'Auto12': return Auto12

    }
}

const getVehicleDamageNIDTO = (data: Array<IVehicleDamage>) => {
    let lst: Array<IVehicleDamageNIDTO> = [];
    if (data.length > 0) {
        data.forEach((x: IVehicleDamage) => {
            lst.push({
                IdTipoDanio: parseInt(x.damageType),
                EsProductoDelAccidente: formatBool(x.isProductAccident),
                NivelDanio: x.damageLevel
            } as IVehicleDamageNIDTO);
        })
    }
    return lst;
}

const getFilesInspection = (data: IReclamoInspeccionNI) => {
    let files: Array<IImageInspectionDto> = [];
    const lstProperties: Array<string> = ['imgAuto1', 'imgAuto2', 'imgAuto3', 'imgAuto4', 'imgAuto5', 'imgAuto6', 'imgAuto7', 'imgAuto8', 'imgAuto9', 'imgAuto10', 'imgAuto11', 'imgAuto12'];
    lstProperties.forEach((prop: string) => {
        let img: IImageInspection = data[prop as keyof typeof data];
        if (img.isModified) {
            files.push({
                AdjuntoBase64: img.value,
                Nombre: `${nameFile[typeFileEnum.inspectionImage]}_${getNewGuid(1)}.png`,
                Peso: 0,
                UltimaModificacion: new Date(),
                Usuario: '',
                Tipo: 'image/png'
            } as IImageInspectionDto);
        }
    });
    return files;
}


const getDefaultVehiclesInvolved = () => {
    const data: IVehiclesInvolved = {
        id: 0,
        carPlate: '',
        identification: '',
        identificationType: '',
        identificationBackImage: undefined,
        identificationFrontImage: undefined,
        firstName1: '',
        firstName2: '',
        lastName1: '',
        lastName2: '',
        cellPhone: '',
        mail: '',
        frontVehicleImage: undefined,
        backVehicleImage: undefined,
        rightVehicleImage: undefined,
        leftVehicleImage: undefined,
        damageVehicleImage: undefined,
    }

    return data;
}

const getNewGuid = (type: number = 0) => {
    if (type === 1)
        return 'xxxxxxxxxxxx'.replace(/[xy]/g, c => {
            const r: number = Math.random() * 16 | 0;
            const v: number = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r: number = Math.random() * 16 | 0;
        const v: number = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

const nameFile = { 
    1 : 'IdentificacionParteFrontal',
    2 : 'IdentificacionParteTrasera',
    3 : 'LicenciaConducir',
    4 : 'EntornoSiniestro',
    5 : 'ParteFrontalVehiculo',
    6 : 'ParteTraseraVehiculo',
    7 : 'ParteDerechaVehiculo',
    8 : 'ParteIzquierdaVehiculo',
    9 : 'DanioVehiculo',
    10 : 'Inspeccion',
    11 : 'DaniosTercero',
    12 : 'Firma',
    13 : 'FirmaConductor',
}

const nameFileVehicleInvolved = { 
    1 : 'IdentificacionParteFrontal',
    2 : 'IdentificacionParteTrasera',
    3 : 'ParteFrontalVehiculo',
    4 : 'ParteTraseraVehiculo',
    5 : 'ParteDerechaVehiculo',
    6 : 'ParteIzquierdaVehiculo',
    7 : 'DanioVehiculo'
}




export {
    buildDataUpdate,
    buildDataVehicleInvolved,
    compressFiles,
    getAutoValue,
    getVehicleDamageNIDTO,
    getFilesInspection,
    getDefaultVehiclesInvolved,
    getNewGuid,
    nameFile,
    nameFileVehicleInvolved
};